// extracted by mini-css-extract-plugin
export default {"ketcher":"styles-module__ketcher__src-labstep-web-core-Chemistry-Editor-Ketcher-_LBmzb"};